import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Link.svg?component
var Link_exports = /* @__PURE__ */ __exportAll({
	default: () => Link_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M13.5 18 12 19.5c-1 1-2.3 1.5-3.7 1.5s-2.7-.6-3.7-1.5c-1-1-1.5-2.3-1.5-3.7s.6-2.7 1.5-3.7l1.5-1.5M10.5 6 12 4.5c1-1 2.3-1.5 3.7-1.5s2.7.6 3.7 1.5c1 1 1.5 2.3 1.5 3.7s-.6 2.7-1.5 3.7l-1.5 1.5M9 15l6-6" }, null, -1)])]);
}
var Link_default = { render: render$1 };
//#endregion
export { Link_exports, Link_default as default, render$1 as render };

//# sourceMappingURL=Link.svg_component.js.map